<template>
    <div>
        <!-- contract edit -->
        <d-contract-lim-edit
            v-model      = "create"
            :contract-id = "-1"
            :type-id     = "typeId"
            :company-id  = "companyId"
            @saved       = "onSaved"
        />
        <!-- contract edit -->

        <c-contract-card-iterator
            :items            = "contracts"
            :selected         = selected
            :preselected      = "preselected"
            :filter           = "textfilter"
            :filter-height    = "167"
            ref               = "iterator"
        >
            <template v-slot:toolbar>
                <div class="v-flex">
                    <c-header-button label="LIM" @click = "onLimCreate" :tooltip="$t('contract.create.lim')" />
                    <c-header-button label="DLS" @click = "onDlsCreate" :tooltip="$t('contract.create.dls')" />
                </div>
            </template>

            <template v-slot:filter>
                <c-contract-lim-card-filter
                    v-model = "filter"
                    @input  = "onFilterChanged"
                />
            </template>

            <template v-slot:card="{ item }">
                <c-contract-lim-card
                    :contract   = "item.item"
                    :background = "`background-unset`"
                    :selected   = "selected"
                    :class      = "{ 'contract-inactive': !item.item.active }"
                    v-on        = "item.item.active ? { selected: onSelected } : {}"
                    @saved      = "onSaved"
                    @renew      = "onRenew"
                />
            </template>
        </c-contract-card-iterator>
    </div>
</template>

<script>

import Core                   from "@/modules/core/service/Core";
import Contract               from "@/modules/msd/company/contract/service/Contract";
import CContractLimCard       from "@/modules/msd/company/contract/components/controls/lim/CContractLimCard";
import CContractCardIterator  from "@/modules/msd/company/contract/components/controls/CContractCardIterator";
import DContractLimEdit       from "@/modules/msd/company/contract/components/controls/lim/DContractLimEdit";
import CHeaderButton          from "@/modules/core/components/utils/CHeaderButton";
import CContractLimCardFilter from "@/modules/msd/company/contract/components/controls/lim/CContractLimCardFilter";

export default {
    name: "CContractLimCardIterator",

    components: {
        CContractLimCardFilter,
        CHeaderButton,
        DContractLimEdit,
        CContractCardIterator,
        CContractLimCard
    },

    props: {
        companyId: {

        },

        contactId: {

        },

        recipientId: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        typeId     : null,
        create     : false,
        selected   : null,
        contracts  : null,
        preselected: null,
        filter  : {
            types   : ["LIM", "DLS"],
            active  : true,
            inactive: false,
        }
    }),

    mounted() {
        this.onFilterChanged();
    },

    watch: {
        companyId () {
            this.selected = null;
            this.onFilterChanged();
        },

        recipientId () {
            this.onFilterChanged();
        },

        contactId () {
            if (this.contactId) {
                this.selected = null;
            }
        }
    },

    methods: {
        onLimCreate () {
            this.typeId = Contract.enums.types.lim;
            this.create = true;
        },

        onDlsCreate () {
            this.typeId = Contract.enums.types.dls;
            this.create = true;
        },

        onSelected (contract) {
            if (this.selected && this.selected.id === contract.id) {
                this.selected = null;
                Core.fire.selected(this,  null);
                return;
            }

            this.selected = contract;
            Core.fire.selected(this,  this.selected);
        },

        onRenew (contract) {
            this.$emit("renew", contract);
        },

        onSaved (contract) {
            this.$refs.iterator.refresh(contract);
        },

        onFilterChanged() {
            if (!this.companyId) {
                return;
            }

            Contract.list(this.companyId, this.createFilter(), (data) => {
                if (!this.recipientId) {
                    this.preselected = null,
                    this.contracts = data;
                    return;
                }

                this.contracts = data.filter (c => (c.invoiceRecipient && c.invoiceRecipient.id  === this.recipientId) || (c.benefitRecipient && c.benefitRecipient.id  === this.recipientId));
                this.$nextTick(() => {
                    this.preselected = "card-preselected"
                })
            });
        },

        createFilter() {
            this.filter.role = 1;
            return this.filter;
        },

        textfilter (item, search) {
            if (!search) {
                return true;
            }

            if (this.includes(item.id.toString(), search)) {
                return true;
            }

            if (item.invoiceRecipient) {
                if (this.includes(item.invoiceRecipient.name, search)) {
                    return true;
                }

                if (this.includes(item.invoiceRecipient.nameAdd, search)) {
                    return true;
                }
            }

            if (item.benefitRecipient) {
                if (this.includes(item.benefitRecipient.name, search)) {
                    return true;
                }

                if (this.includes(item.benefitRecipient.nameAdd, search)) {
                    return true;
                }
            }

            return !item.invoiceRecipient && !item.benefitRecipient;
        },

        includes (text, search) {
            if (!text) {
                return false;
            }

            return text.toUpperCase().includes(search.toUpperCase())
        }

    }
}
</script>

<style scoped>

.contract-inactive ::v-deep .v-card {
    cursor: default !important;
}

</style>
